import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import parse from "html-react-parser"

import { MainDiv } from "../component";

import loadingImg from "../asset/img/loading.gif";

import  "../asset/style/project.css"
import { useEffect, useRef, useState } from "react";

function Project() {
    const {repo_name}= useParams();
    const hash= useLocation().hash;
    const node= useRef(null);
    const [res, setRes]= useState(null);
    const [loading, setLoading] = useState(true);

    //Update result
    useEffect(()=>{
      setLoading(true);

      let resp;
      let metadata = {
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };

    try {
      (async ()=>{
        resp= await axios.get(process.env.REACT_APP_API_BE_URL + "/api/v1/projects/"+repo_name, metadata);
        setRes(resp);
        setLoading(false);
      })();
    } catch (err) {
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(err.response);
      }
      setRes(null);
      setLoading(false);
    }
    
    },[repo_name]);

    let content, result, status;
    if (res !== null) {
      status = res.status;
      result = res.data.content !== undefined ? res.data.content : undefined;
    } else {
      result = undefined;
      status = undefined;
    }

    
    //scroll into view effect.
    useEffect(()=>{
      let id= typeof hash === "string" ? hash.replace('#', '#user-content-') : '';
      if (id.length > 0 && node.current) {
        let view= node.current.querySelector(id);
        view.scrollIntoView({ behavior: "smooth" });
      }
    });

    if(status=== 200){
      let opt = {
        replace: (domNode) => {
          if (domNode.name === "img"){
            let src = `https://raw.githubusercontent.com/${process.env.REACT_APP_GH_USERNAME}/${repo_name}/master/${domNode.attribs.src}`;
            let alt = domNode.attribs.alt || "image";
            let style = { maxWidth: "90%", margin: "2% auto"}
            return <img src={src} alt={alt} style={style} />;
          }
        },
      };
      content= (<div className="project" ref={node}>{parse(result, opt)}</div>);
    }else if(status !== 200 && !loading){ content= (<span className="error">Content not available.</span>);}
    
      
    return (
      <MainDiv>
        <h1>
          <Link to="/portfolio">Portfolio</Link>&nbsp;
          <FontAwesomeIcon icon={faArrowRight} />
          &nbsp;{`${repo_name}`}
        </h1>
        {loading ? (
          <img src={loadingImg} alt="Loading..." className="loadingGif" />
        ) : (
          content
        )}
      </MainDiv>
    );
}

export default Project;